import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// PWA — register the service worker in production only. Dev builds hot-reload
// aggressively and a cached SW breaks that loop. We ship the SW from public/
// so it's served at the site root and can claim the whole scope.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.warn("[PWA] service worker registration failed:", err));
  });
}

// Tag the body when running as an installed PWA so CSS can apply iOS/Android
// safe-area padding. The `@media (display-mode: standalone)` query in index.css
// handles most browsers; this class covers older iOS Safari, which reports
// `navigator.standalone` but not always the display-mode media match.
(function markStandalone() {
  try {
    const isStandalone =
      (typeof navigator !== "undefined" && navigator.standalone === true) ||
      (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches);
    if (isStandalone) document.body.classList.add("fm-standalone");
  } catch { /* ignore — non-critical UI tweak */ }
})();
